import { render, staticRenderFns } from "./MinChecks.vue?vue&type=template&id=8d950ee8&"
import script from "./MinChecks.vue?vue&type=script&lang=js&"
export * from "./MinChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports